import { CopyIcon, PlayIcon } from "assets";
import { CustomTooltip } from "components";
import { FeaturedAdsProps } from "modules/featured_ads/state/actionType";
import { SpecialOfferProps } from "modules/special_offer/state/actionType";
import { FeaturedAdsEnum } from "props/enum";
import { useEffect, useState } from "react";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";

interface Props {
  specailOfferData: SpecialOfferProps;
}

export const PreviewImage: React.FC<Props> = ({ specailOfferData }) => {
  const [posterUrl, setPosterUrl] = useState<string | null>(null);
  const [copiedField, setCopiedField] = useState<string | null>(null);
  // const imageUrl = specailOfferData.image;
  const featuredAdsName = specailOfferData.title;
  const handleCopy = async (value: string, label: string) => {
    const success = await copyToClipboard(value);
    if (success) {
      setCopiedField(label);
      setTimeout(() => {
        setCopiedField(null);
      }, 1500);
    }
  };

  // useEffect(() => {
  //   const fetchVideoMeta = async () => {
  //     try {
  //       const videoId = featuredData?.video.toString();
  //       const url = `${process.env.REACT_APP_VDO_CIPHER_BASE_URL}${videoId}`;
  //       const response = await fetch(url, {
  //         method: "GET",
  //         headers: { Accept: "application/json" },
  //       });

  //       if (response.ok) {
  //         const data = await response.json();
  //         const thumbnail = data?.posters?.[0]?.url;
  //         setPosterUrl(thumbnail);
  //       }
  //     } catch (err: any) {
  //       console.error("Failed to fetch thumbnail", err);
  //     }
  //   };

  //   if (featuredData.featured_type === FeaturedAdsEnum.video) {
  //     fetchVideoMeta();
  //   }
  // }, [featuredData]);

  // const videoHeader = [
  //   "Video Id",
  //   "Identifier",
  //   "Playback info",
  //   "OTP",
  //   "Upload Status",
  // ];
  // const videoDetails = [
  //   featuredData.video,
  //   featuredData.identifier,
  //   featuredData.playback_info,
  //   featuredData.otp,
  //   featuredData.upload_status,
  // ];

  // const isVideo = featuredData.featured_type === FeaturedAdsEnum.video;
  // const imgSrc = isVideo ? posterUrl ?? undefined : imageUrl;

  return (
    <div className="p-4">
      {/* <h2 className="w-full text-center text-lg font-bold mb-2">
        {featuredAdsName}
      </h2>
      <div className="relative group w-fit mx-auto">
        <img src={imgSrc} alt={featuredAdsName} className="rounded-md shadow-md" />
        {isVideo && (
          <div className="absolute inset-0 flex items-center justify-center">
            <PlayIcon className="size-12 text-white opacity-80 group-hover:opacity-100 transition-opacity" />
          </div>
        )}
      </div>

      {isVideo && (
        <div className="grid grid-cols-3 gap-4 mt-4 text-sm">
          <div className="font-semibold space-y-1 col-span-1">
            {videoHeader.map((item, index) => (
              <div key={index} className="pb-1">{item}</div>
            ))}
          </div>
          <div className="space-y-1 break-all col-span-2">
            {videoDetails.map((value, index) => {
              const label = videoHeader[index];
              const isCopyable =
                label !== "Upload Status" && typeof value === "string";
              const displayValue = value
                ? value.length > 20
                  ? value.slice(0, 20) + "..."
                  : value
                : "N/A";

              return (
                <div key={index} className="flex items-center gap-2">
                  <span>{displayValue}</span>
                  {isCopyable && value && (
                    <CustomTooltip
                      title={copiedField === label ? "Id copied!" : "Copy Id"}
                      placement="right"
                    >
                      <button
                        onClick={() => handleCopy(value, label)}
                        className="p-1 hover:text-blue-600"
                      >
                        <CopyIcon className="size-4" />
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )} */}
    </div>
  );
};
